export default "__VITE_ASSET__O32A26C1__"